export const PBX_SETTINGS_ENDPOINTS = {
  PBX_V2: (pbxId: number) => `/app/v2/pbxes/${pbxId}/`,
  PROVIDER_GATEWAYS_V2: '/app/v2/provider-gateways/',
  PROVIDER_GATEWAY_V2: (providerGatewayId: number) =>
    `/app/v2/provider-gateways/${providerGatewayId}/`,
  SERVER_GROUPS_V2: '/app/v2/server-groups/',
  SYSTEM_SETTINGS_V2: (pbxId: number) =>
    `/app/v2/pbx/${pbxId}/system-settings/`,
  PHONE_NUMBERS: '/app/v1/phone-numbers/',
  EXTENSIONS: '/app/v1/extensions/',
  VIRTUAL_FAX_MACHINES: (pbxId: number) =>
    `/app/v1/pbxes/${pbxId}/virtual-fax-machines/`,
  COMPANIES: '/internal/v1/companies/',
} as const
